import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import Chip from "@mui/material/Chip";
import { ResourceType } from "@/services/cloudchipr.api";
import { getResourceTypeName } from "@/utils/helpers/resources/getResourceTypeName";
import { LiveUsageResourceInfoStatusForMultiAccount } from "@/components/pages/live-usage-mgmt/components/resources-area/resource-info/LiveUsageResourceInfoStatusForMultiAccount";

interface LiveUsageResourceSingleHeaderProps {
  resourceType: ResourceType;
  count?: number;
}

export const LiveUsageResourceSingleHeader: FC<
  LiveUsageResourceSingleHeaderProps
> = ({ resourceType, count }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center" p={1} pb={0}>
      <Typography variant="h6">
        {getResourceTypeName(resourceType, { type: "long" })}
      </Typography>

      <LiveUsageResourceInfoStatusForMultiAccount resourceType={resourceType} />

      {typeof count === "number" && (
        <Chip
          label={count}
          size="small"
          sx={{
            color: "text.secondary",
            fontWeight: "medium",
          }}
        />
      )}
    </Stack>
  );
};
